import { Controller } from "@hotwired/stimulus"
import { requestConfirm } from "../util"

export default class extends Controller {
  async toggle(event) {
    const confirmationModaName = event.target.checked ? "enable-feature-flag" : "disable-feature-flag"

    // Since checkbox toggles before the event is fired, we need to temporary revert the change
    event.target.checked = !event.target.checked

    const confirmationResult = await requestConfirm({ modal: confirmationModaName })
    if (!confirmationResult) {
      event.preventDefault()
      return
    }

    event.target.checked = !event.target.checked

    if (event.target.checked)
      event.target.value = "true"
    else
      event.target.value = "false"

    event.target.form.requestSubmit()
  }
}
